export default [
  { to: 'allmant', title: 'Allmänt' },
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'falckspecifikt', title: 'Falckspecifikt' },
  { to: 'arkiv', title: 'Arkiv' },
  { to: 'dosberakning', title: 'Dosberäkning' },
];
